import { useAppAbility } from "@/casl";
import { AppAction, AppSubject } from "@/casl/types";
import { Panel, Typography } from "@/components/atoms";
import { PageList } from "@/components/molecules";
import { DispatchSettings } from "./DispatchSettings/DispatchSettings";

type Subpage = {
  name: string;
  desc: string;
  to: string;
  icon: string;
  permission?: [AppAction, AppSubject];
};

const subpages: Subpage[] = [
  {
    name: "Dispatch Settings",
    desc: "Configuration settings to determine when to dispatch jobs.",
    to: "dispatch-settings",
    icon: "Export",
    permission: ["manage", "providerConfigProfileAdvanced"],
  },
];

export const DispatchPanel = () => {
  const ability = useAppAbility();

  return (
    <Panel>
      <Typography variant="h3">Dispatch Settings</Typography>
      <PageList className="-mx-5 mt-2">
        {subpages.map(({ name, desc, to, icon, permission }) => (
          <PageList.Item
            key={name}
            title={name}
            description={desc}
            to={to}
            icon={icon}
            locked={permission ? !ability.can(permission[0], permission[1]) : false}
          />
        ))}
      </PageList>
    </Panel>
  );
};

DispatchPanel.DispatchSettings =  DispatchSettings;
